/**
 * Helper function to check whether test is running
 * @returns whether test is running
 */
export const checkIfTestRun = (): boolean => {
  // Check if Jest or Cypress tests are running
  try {
    return process.env.JEST_WORKER_ID !== undefined;
  } catch (e) {
    // @ts-ignore
    return !!window.Cypress;
  }
};
